import { useState } from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import ContactBlock from "../components/ContactBlock";
import { Reveal } from "../components/Reveal";
import { usePageMeta } from "../hooks/usePageMeta";

export default function ContactPage() {
    const [interest, setInterest] = useState("");

    usePageMeta(
        "Contact GoMedVoyage | Start a Conversation",
        "Get in touch with GoMedVoyage — for patients exploring healthcare options, hospitals, investors and strategic partners."
    );

    return (
        <div data-testid="contact-page">
            <Header />
            <main>
                <section className="pt-40 pb-24 bg-gradient-to-b from-tint-blue to-white">
                    <div className="max-w-7xl mx-auto px-6 lg:px-8">
                        <Reveal>
                            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-green">Contact</p>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <h1 data-testid="contact-headline" className="mt-6 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter text-brand-blue">
                                Start a conversation.
                            </h1>
                        </Reveal>
                        <Reveal delay={0.2}>
                            <p className="mt-6 max-w-2xl text-base md:text-lg leading-relaxed text-slate-600">
                                Choose who you are below — the form will adapt — or simply write to us directly.
                            </p>
                        </Reveal>
                    </div>
                </section>
                <section className="pb-28 bg-white">
                    <div className="max-w-7xl mx-auto px-6 lg:px-8">
                        <ContactBlock selectedInterest={interest} onSelect={setInterest} testidPrefix="contact" />
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
